import styles from '@hts/entities/Card/styles/InfoContent/TextFields/CardKeyboard.module.scss';
import { IKeyboardPosState } from '@hts/entities/Card/types';
import { ELanguageType } from '@hts/shared/enums';
import { forwardRef, memo, useCallback, useMemo, useState } from 'react';
import Keyboard from 'react-simple-keyboard';

import '@hts/entities/Card/styles/InfoContent/TextFields/CardKeyboard.scss';
import 'react-simple-keyboard/build/css/index.css';

interface ICardKeyboardProps {
  showKeyboard: boolean;
  keyboardLang: ELanguageType;
  keyboardPos: IKeyboardPosState;
  activeKeyboardTextFieldId: string | null;
  setKeyboardLang: (lang: string) => void;
  handleChangeText: (id: string, newText: string) => void;
}

export const CardKeyboard = memo(
  forwardRef<unknown, ICardKeyboardProps>(
    (
      {
        showKeyboard,
        activeKeyboardTextFieldId,
        keyboardLang,
        keyboardPos,
        setKeyboardLang,
        handleChangeText,
      },
      keyboardRef
    ) => {
      const [isShifted, setIsShifted] = useState(false);

      const keyboarLayout = useMemo(
        () => ({
          default: [
            '1 2 3 4 5 6 7 8 9 0 - = {bksp}',
            "/ ' \u05e7 \u05e8 \u05d0 \u05d8 \u05d5 \u05df \u05dd \u05e4 ] [ :",
            '\u05e9 \u05d3 \u05d2 \u05db \u05e2 \u05d9 \u05d7 \u05dc \u05da \u05e3 ,',
            '\u05d6 \u05e1 \u05d1 \u05d4 \u05e0 \u05de \u05e6 \u05ea \u05e5 . "',
            '{shift} @ {space} {ENG}',
          ],
          shift: [
            '! @ # $ % ^ & * ( ) _ + {bksp}',
            '? " \u05e7 \u05e8 \u05d0 \u05d8 \u05d5 \u05df \u05dd \u05e4 } { |',
            '\u05e9 \u05d3 \u05d2 \u05db \u05e2 \u05d9 \u05d7 \u05dc \u05da \u05e3 ,',
            '\u05d6 \u05e1 \u05d1 \u05d4 \u05e0 \u05de \u05e6 \u05ea \u05e5 . "',
            '{shift} @ {space} {ENG}',
          ],
        }),
        []
      );

      const keyboardLayoutEng = useMemo(
        () => ({
          default: [
            '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
            'q w e r t y u i o p [ ] \\',
            "a s d f g h j k l ; '",
            'z x c v b n m , . /',
            '{shift} @ {space} {עבר}',
          ],
          shift: [
            '~ ! @ # $ % ^ & * ( ) _ + {bksp}',
            'Q W E R T Y U I O P { } |',
            'A S D F G H J K L : "',
            'Z X C V B N M < > ?',
            '{shift} @ {space} {עבר}',
          ],
        }),
        []
      );

      const layout = keyboardLang === ELanguageType.HEBREW ? keyboarLayout : keyboardLayoutEng;

      const keyBoardOnChange = useCallback(
        (input: string) => {
          if (!activeKeyboardTextFieldId) return;

          handleChangeText(activeKeyboardTextFieldId, input);
        },
        [handleChangeText, activeKeyboardTextFieldId]
      );

      const onKeyPress = useCallback((button: string) => {
        if (button === '{עבר}') {
          setKeyboardLang('hebrew');
        }

        if (button === '{ENG}') {
          setKeyboardLang('english');
        }

        if (button === '{shift}') {
          setIsShifted((prev) => !prev);
        }
      }, []);

      return (
        <div
          className={styles.container}
          style={{ opacity: showKeyboard ? 1 : 0, visibility: showKeyboard ? 'visible' : 'hidden' }}
        >
          <div className={styles.contentContainer} style={keyboardPos}>
            <Keyboard
              keyboardRef={(r) => ((keyboardRef as any).current = r)}
              syncInstanceInputs
              layoutName={isShifted ? 'shift' : 'default'}
              layout={layout}
              display={{
                '{עבר}': 'עבר',
                '{ENG}': 'ENG',
                '{space}': ' ',
                '{bksp}': 'backspace',
                '{shift}': 'shift',
              }}
              onChange={keyBoardOnChange}
              onKeyPress={onKeyPress}
            />
          </div>
        </div>
      );
    }
  )
);
